import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export const About = () => {
  const {
    t
  } = useLanguage();
  const bullets = t('about.bullets');
  return <section className="bg-background" data-id="element-16">
      <div className="flex flex-col md:flex-row min-h-[80vh]" data-id="element-17">
        {/* Left: Image with Ken Burns */}
        <div className="w-full md:w-1/2 relative overflow-hidden h-[50vh] md:h-auto" data-id="element-18">
          <div className="absolute inset-0 bg-cover bg-center animate-ken-burns origin-center" style={{
          backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8wQ1uy5Sdy1edMjs48WCoy/mejora_la_foto_a_8k_202605062043.jpg)'
        }} data-id="element-19" />
          <div className="absolute inset-0 bg-black/20" data-id="element-20" />
        </div>

        {/* Right: Content */}
        <div className="w-full md:w-1/2 bg-gradient-to-br from-[#1a1a1a] to-background p-10 md:p-20 flex flex-col justify-center" data-id="element-21">
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-22">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-23">
              {t('about.heading')}
            </h2>

            <div className="space-y-6 text-lg text-gray-300 leading-relaxed mb-12" data-id="element-24">
              <p data-id="element-25">{t('about.p1')}</p>
              <p data-id="element-26">{t('about.p2')}</p>
              <p className="text-2xl font-serif font-bold text-primary my-8 border-l-4 border-primary pl-6 py-2" data-id="element-27">
                {t('about.p3a')}
                <br data-id="element-28" />
                {t('about.p3b')}
              </p>
              <p data-id="element-29">{t('about.p4')}</p>
            </div>

            <ul className="space-y-4 text-white font-medium" data-id="element-30">
              {[{
              icon: '⚡',
              text: bullets[0]
            }, {
              icon: '🎯',
              text: bullets[1]
            }, {
              icon: '📱',
              text: bullets[2]
            }, {
              icon: '🇦🇷',
              text: bullets[3]
            }].map((item, i) => <motion.li key={i} className="flex items-center gap-4 text-lg" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5 + i * 0.1,
              duration: 0.5
            }} data-id="element-31">
                  <span className="text-2xl" data-id="element-32">{item.icon}</span>
                  {item.text}
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};